<template>
    <div class="B2BNumbers container flex flex-col items-center justify-between bg-white dark:bg-surface-card py-16 lg:flex-row">
        <div class="mb-10 w-full max-w-[570px] lg:mb-0 lg:w-1/2">
            <CText variant="muted">
                {{ text }}
            </CText>
        </div>

        <StatsBlock variant="B2B" />
    </div>
</template>

<script setup lang="ts">
import { B2BType } from '#shared/types/B2B'
import StatsBlock from '@/components/common/StatsBlock.vue'
import { computed } from 'vue'

const TEXT = {
    [B2BType.DEFAULT]:
        'Sme nezisková organizácia a všetky naše aktivity robíme len vďaka podpore partnerov a donorov. Veríme však, že dopad, ktorý spoločne prinášame, túto podporu mnohonásobne prevyšuje.',

    [B2BType.GOV]:
        'Sme online miesto pre rast organizácií a jednotlivcov. V GROWNi pomáhame rozvíjať hodnotovo orientovaných jednotlivcov a organizácie, ktorým záleží na tom, aby ich práca mala pozitívny dopad na Slovensko.',

    [B2BType.NGO]: ''
} as const

const props = withDefaults(
    defineProps<{
        type?: B2BType
    }>(),
    {
        type: B2BType.DEFAULT
    }
)

const text = computed(() => TEXT[props.type])
</script>